import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
import { CompetitorsCTA } from './CompetitorsCTA';
import { StoryCTA } from './StoryCTA';
import { IdeaCTA } from './IdeaCTA';
import { ExpectationsCTA } from './ExpectationsCTA';
import { AgreementCTA } from './AgreementCTA';
import { useLanguage } from '../i18n/LanguageContext';
export function MarketContext() {
  const {
    t
  } = useLanguage();
  const cards = t('market.cards') as {
    title: string;
    desc: string;
  }[];
  return <section className="py-24 px-6 bg-zinc-950" data-id="element-120">
      <div className="max-w-4xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex items-center gap-3 mb-8" data-id="element-122">
          <div className="w-10 h-10 rounded-full bg-magenta-500/10 flex items-center justify-center" data-id="element-123">
            <TrendingUp className="w-5 h-5 text-magenta-500" data-id="element-124" />
          </div>
          <span className="text-sm uppercase tracking-widest text-zinc-500 font-medium" data-id="element-125">
            {t('market.opportunity')}
          </span>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="font-serif text-2xl md:text-4xl leading-snug text-zinc-200 mb-12" data-id="element-126">
          {t('market.p1Start')}
          <span className="text-magenta-500" data-id="element-127">{t('market.p1Highlight')}</span>
          {t('market.p1End')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12" data-id="element-128">
          {cards.map((card, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6" data-id="element-129">
              <p className={`font-serif text-4xl mb-2 ${i === 0 ? 'text-cyan-300' : i === 1 ? 'text-magenta-500' : 'text-zinc-200'}`} data-id="element-130">
                {card.title}
              </p>
              <p className="text-sm text-zinc-500" data-id="element-131">{card.desc}</p>
            </div>)}
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.3
      }} className="text-lg text-zinc-400 font-light leading-relaxed" data-id="element-132">
          {t('market.p2Start')}
          <span className="text-zinc-200 font-medium" data-id="element-133">
            {t('market.p2Highlight')}
          </span>
          {t('market.p2End')}
        </motion.p>

        <CompetitorsCTA data-id="element-134" />
        <StoryCTA data-id="element-135" />
        <IdeaCTA data-id="element-136" />
        <ExpectationsCTA data-id="element-137" />
        <AgreementCTA data-id="element-138" />
      </div>
    </section>;
}